'use client'
import { useParams } from 'next/navigation'
import { Locale } from './types'

export function useLocale(): Locale | undefined {
  const params = useParams<{ locale?: Locale }>()
  return params?.locale ?? undefined
}
